import { useSyncExternalStore } from 'react';
import { DEFAULT_SETTINGS, type TenantSettings } from '@dairy/shared';
import { sessionStore, type SessionProfile, type SessionState } from './session';

export function useSession(): SessionState {
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.get);
}

/** The signed-in user (pages behind RequireAuth only). */
export function useProfile(): SessionProfile {
  const s = useSession();
  if (!s.profile) throw new Error('useProfile outside a signed-in page');
  return s.profile;
}

export function useSettings(): TenantSettings {
  return useSession().profile?.settings ?? DEFAULT_SETTINGS;
}

export function useIsOwner(): boolean {
  return useSession().profile?.role === 'OWNER';
}
